import { userConstants } from "../../constant";
export function users(state = [], action) {
  switch (action.type) {
    case userConstants.GET_USER_PROFILE:
      return { profile: action.profile };
    case userConstants.SET_ADDRESS:
      return [...state, { address: action.address }];
    case userConstants.GET_ADDRESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          shipping_addresses: action.address,
        },
      };
    case userConstants.SET_DEFAULT_ADDRESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          shipping_addresses: action.address,
        },
      };
    default:
      return state;
  }
}
